import { FormBehavior } from './index';
import programCompletionTemplate from '../templates/programcompletion.json';

const today = () => new Date().toISOString().split('T')[0];

export const programCompletionBehavior: FormBehavior = {
  renderHeader: () => null,

  getTemplate: () => {
    return JSON.stringify(programCompletionTemplate);
  },

  getInitialData: (props) => {
    const { participant, user } = props;
    const fullName = participant?.name
      ? `${participant.name.firstName || ''} ${participant.name.lastName || ''}`.trim()
      : '';
    const userName = user?.realname || '';

    return {
      member_name: fullName,
      member_cin: participant?.cin || '',
      lead_care_manager_name: userName,
      lcm_signature: userName,
      completion_date: today(),
    };
  },

  supportsAltTemplate: false,

  customActions: [],

  customLogic: {
    onBeforeCreate: (data) => data,
    onBeforeUpdate: (data) => data,
    onAfterLoad: (data) => data,
  },
};
